<template>
  <div class="id-card-upload">
    <h3 class="title">证件上传要求</h3>
    <p class="requirements">请确保证件边框完整、字迹清晰可见、亮度均匀。</p>

    <div class="upload-container">
      <!-- 证件正面上传 -->
      <div class="upload-box">
        <h4>证件正面</h4>
        <div style="height: 23px;" />
        <div class="upload-area" @click="triggerFrontUpload">
          <input
            type="file"
            ref="frontInput"
            class="file-input"
            accept="image/*"
            @change="handleFrontChange"
          />
          <img
            v-if="frontImage && frontFileProgress === 100"
            :src="frontImage"
            class="preview-image"
            alt="证件正面"
          />
          <div
            v-if="frontImage && frontFileProgress === 100"
            class="clear-icon"
            @click.stop="clearFrontImage"
          >
            <i class="el-icon-delete"></i>
          </div>

          <div v-else class="upload-content">
            <template v-if="frontFileProgress === 100 && !frontImage">
              <div class="upload-icon">+</div>
              <div class="upload-text">点击上传</div>
            </template>
            <el-progress
              v-else
              type="circle"
              :percentage="frontFileProgress"
              :stroke-width="8"
              :width="80"
              class="circle-progress"
            ></el-progress>
          </div>
        </div>
      </div>

      <!-- 证件反面上传 -->
      <div class="upload-box">
        <h4>证件反面</h4>
        <p class="back-card-tips">
          (如上传的证件为护照，此处上传与证件正面一样的照片即可)
        </p>
        <div class="upload-area" @click="triggerBackUpload">
          <input
            type="file"
            ref="backInput"
            class="file-input"
            accept="image/*"
            @change="handleBackChange"
          />
          <img
            v-if="backImage && backFileProgress === 100"
            :src="backImage"
            class="preview-image"
            alt="证件反面"
          />
          <div
            v-if="backImage && backFileProgress === 100"
            class="clear-icon"
            @click.stop="clearBackImage"
          >
            <i class="el-icon-delete"></i>
          </div>

          <div v-else class="upload-content">
            <template v-if="backFileProgress === 100 && !backImage">
              <div class="upload-icon">+</div>
              <div class="upload-text">点击上传</div>
            </template>
            <el-progress
              v-else
              type="circle"
              :percentage="backFileProgress"
              :stroke-width="8"
              :width="80"
              class="circle-progress"
            ></el-progress>
          </div>
        </div>
      </div>
    </div>

    <button class="submit-btn" :disabled="!isComplete" @click="handleSubmit">
      确认提交
    </button>
  </div>
</template>

<script>
import { Progress } from 'element-ui'
import { addExamIdCard } from '@/apis/exam.api'
import { sdkDownloading, sdkUploader } from '@/utils/upload-sdk'
import { getFileSufix, getExamId, resolveUploadFileUrl } from '@/utils'
const WATERMARK = '?watermark/4/text/5q-U6LWb6Lqr5Lu95qC46aqM5LiT55So/fontsize/400/fill/Z3JheQ==/dissolve/50/rotate/30/uw/180/uh/180/resize/1'
export default {
  name: 'IDCardUpload',
  components: {
    ElProgress: Progress
  },
  data() {
    return {
      frontImage: '',
      backImage: '',
      frontImageSecret: '',
      backImageSecret: '',
      frontFileProgress: 100,
      backFileProgress: 100
    }
  },

  computed: {
    isComplete() {
      return this.frontImage && this.backImage && this.frontImageSecret && this.backImageSecret
    }
  },

  methods: {
    showMessage(text, type = 'error') {
      this.$message[type](text)
    },

    validateFile(file, e) {
      // 排除svg 和 gif
      const isImage = file.type.indexOf('image') !== -1 && file.type.indexOf('svg') === -1 && file.type.indexOf('gif') === -1
      const isLt5M = file.size / 1024 / 1024 < 5

      if (!isImage) {
        this.showMessage('只能上传图片文件！')
        e.target.value = ''
        return false
      }
      if (!isLt5M) {
        this.showMessage('图片大小不能超过 5MB！')
        e.target.value = ''
        return false
      }
      return true
    },

    handleFileUrlChange(fileUrl, side) {
      if (side === 'front') {
        this.frontImage = fileUrl
        this.showMessage('正面照片上传成功', 'success')
      } else {
        this.backImage = fileUrl
        this.showMessage('反面照片上传成功', 'success')
      }
    },

    triggerFrontUpload() {
      this.$refs.frontInput.click()
    },

    triggerBackUpload() {
      this.$refs.backInput.click()
    },
    async handleFileChange(e, side) {
      const files = e.target.files
      if (!files || files.length === 0) {
        this.showMessage('请选择文件')
        return
      }
      const file = files[0]
      if (!this.validateFile(file, e)) return
      if (file) {
        if (side === 'front') {
          this.frontFileProgress = 0
        } else {
          this.backFileProgress = 0
        }

        const fileSufix = getFileSufix(file.name)
        console.log(fileSufix, file.name, 'fileSufix')
        const filename = `${Date.now()}_${Math.floor(Math.random() * 1000)}.${fileSufix}`
        try {
          const { url: fileUrl } = await sdkUploader(file, {
            filename: `eduTest/upload/idcard/${filename}`,
            isPrivate: true,
            onprogress: (progress) => {
              const progressPercent = Math.min(99.99, Number(progress.total.percent.toFixed(2)))
              if (side === 'front') {
                this.frontFileProgress = progressPercent
              } else {
                this.backFileProgress = progressPercent
              }
            }
          })
          const fileBolbUrl = URL.createObjectURL(file)
          if (side === 'front') {
            this.frontImage = fileBolbUrl
            this.frontFileProgress = 100
          } else {
            this.backImage = fileBolbUrl
            this.backFileProgress = 100
          }

          const fileSecret = fileUrl + WATERMARK
          const resolvedUrl = resolveUploadFileUrl(fileSecret)
          const { download_url: realFileUrl } = await sdkDownloading(resolvedUrl, {
            projectName: 'blueboat'
          })

          if (side === 'front') {
            this.frontImageSecret = fileSecret
            this.handleFileUrlChange(realFileUrl, 'front')
          } else {
            this.backImageSecret = fileSecret
            this.handleFileUrlChange(realFileUrl, 'back')
          }
        } catch (error) {
          if (side === 'front') {
            this.frontFileProgress = 100
            this.frontImage = ''
            this.frontImageSecret = ''
          } else {
            this.backFileProgress = 100
            this.backImage = ''
            this.backImageSecret = ''
          }
          this.showMessage('上传失败')
        }
        e.target.value = ''
      } else {
        this.showMessage('请选择文件')
      }
    },

    async handleFrontChange(e) {
      this.handleFileChange(e, 'front')
    },

    async handleBackChange(e) {
      this.handleFileChange(e, 'back')
    },

    async handleSubmit() {
      if (!this.isComplete) {
        this.showMessage('请先上传证件正反面照片')
        return
      }
      await addExamIdCard({
        examId: this.$route.query.examId || getExamId(),
        identity_card_front: this.frontImageSecret,
        identity_card_back: this.backImageSecret
      })
      // 在这里处理提交逻辑，例如发送到服务器
      this.showMessage('提交成功', 'success')
      this.$emit('nextStep')
    },

    clearFrontImage() {
      this.frontImage = ''
      this.frontFileProgress = 100
      this.$refs.frontInput.value = ''
    },

    clearBackImage() {
      this.backImage = ''
      this.backFileProgress = 100
      this.$refs.backInput.value = ''
    }
  }
}
</script>

<style scoped>
.id-card-upload {
  padding: 20px 50px;
  width: 800px;
  margin: 0 auto;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.title {
  margin-bottom: 10px;
  font-size: 18px;
  color: #333;
}

.requirements {
  margin-bottom: 20px;
  color: #666;
  font-size: 14px;
}

.upload-container {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.upload-box {
  flex: 1;
}

.upload-box h4 {
  margin-bottom: 4px;
  color: #333;
}

.upload-area {
  position: relative;
  width: 100%;
  cursor: pointer;
}

.file-input {
  display: none;
}

.upload-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 180px;
  border: 2px dashed #ddd;
  border-radius: 8px;
  transition: border-color 0.3s;
  position: relative;
}

.upload-area:hover .upload-content {
  border-color: #666;
}

.upload-icon {
  font-size: 32px;
  color: #999;
  margin-bottom: 8px;
}

.upload-text {
  color: #999;
  font-size: 14px;
}

.preview-image {
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 8px;
  border: 2px solid #ddd;
  position: relative;
}

.message {
  margin: 10px 0;
  padding: 10px;
  border-radius: 4px;
  text-align: center;
}

.message.error {
  background-color: #fee;
  color: #c33;
}

.message.success {
  background-color: #efe;
  color: #3c3;
}

.submit-btn {
  width: 150px;
  padding: 12px;
  font-size: 16px;
  color: white;
  background-color: #007bff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
  margin: 20px;
  margin-left: 50%;
  transform: translateX(-50%);
}

.submit-btn:hover:not(:disabled) {
  background-color: #34495e;
}

.submit-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.progress-bar {
  margin-top: 10px;
  width: 100%;
}

.circle-progress {
  margin: 0;
  padding: 0;
}

.upload-content .el-progress {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.clear-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 24px;
  height: 24px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s;
  z-index: 1;
}

.clear-icon i {
  color: white;
  font-size: 16px;
}

.upload-area:hover .clear-icon {
  opacity: 1;
}

.clear-icon:hover {
  background-color: rgba(0, 0, 0, 0.7);
}

.back-card-tips {
  font-size: 12px;
  color: #666;
  margin-bottom: 6px;
}
</style>
